<script>
  import Icon from '../components/Icon.svelte';
  import { activeCategory, activeCategoryItem } from '../stores';
  import { categories } from '../config';

  const onClickCategory = cat => activeCategory.set(cat);
</script>

<style>
  .km-buttons {
    display: flex;
    flex-wrap: wrap;
  }

  .km-category {
    padding: 1px 4px;
    background: #f3f3f3;
    border: none;
    font-size: 12px;
    height: 42px;
    letter-spacing: 0.25px;
    font-family: 'axiforma', Arial, sans-serif;
    font-weight: 700;
    cursor: pointer;
    border-radius: 4px !important;
    margin-right: 10px;
    transition: background-color 300ms;
    margin-bottom: 10px;
    user-select: none;
    display: flex;
    align-items: center;
  }

  .km-category:hover {
    background-color: rgb(230, 230, 230);
  }

  .km-category:focus {
    outline: none;
  }

  :global(.km-category svg) {
    display: none;
  }

  /* @media (min-width: 800px) { */
  :global(.km-category svg) {
    display: block;
    width: 32px;
    height: 32px;
  }
</style>

<div class="km-categories">
  <div class="km-title">
    Aktive Produkt-Kategorie:
    <span style={`color: ${$activeCategoryItem.color};`}>
      {$activeCategoryItem.label}
    </span>
  </div>

  <div class="km-buttons">
    {#each categories as cat}
      <button
        class="km-category"
        class:inactive={cat.key !== $activeCategory}
        style={cat.key === $activeCategory ? `background-color: ${cat.minColor}; color: ${cat.color}; border: none; ${!cat.key ? 'padding: 0 10px;' : ''}` : !cat.key ? 'padding: 0 10px;' : null}}
        on:click={() => onClickCategory(cat.key)}>
        {#if cat.key}
          <Icon name={cat.key} class={cat.key} />
        {/if}
        {#if !cat.key}{cat.label}{/if}
      </button>
    {/each}
  </div>
</div>
